import { sendToMixpanel, getUserProps } from '../mixpanel';
import type { SearchResultsBaseProperties } from './search-results-base-properties';

export interface TrackTapSearchProps {
  interactionCTA?: string;
  baseProperties?: SearchResultsBaseProperties;
}

export default ({
  interactionCTA,
  baseProperties = {},
}: TrackTapSearchProps = {}): void =>
  sendToMixpanel('Tap Search', {
    ...baseProperties,
    ...getUserProps(),
    ...(interactionCTA && { interactionCTA }),
  });
